import { Patology, PatologyQuery } from '../models/Patology'
import { Observable } from 'rxjs'
import { Container, IInit } from '../../../common/container/Container'
import { Query } from '../../../common/api/Query'
import { IStatusService } from '../../../common/status/StatusService'
import { PatologyDTO } from '../models/PatologyDTO'
import { ItemList } from '../../../common/models/ItemList'
import { PatologyApi } from '../api/PatologyApi'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IPatologyService extends IInit {
  getByID(id: string): Observable<Patology | undefined>

  getFilteredList(q: Query<PatologyQuery>): Observable<ItemList<Patology>>

  add(e: PatologyDTO): Observable<Patology | undefined>

  update(e: PatologyDTO): Observable<Patology | undefined>

  delete(id: string): Observable<boolean>
}

export class PatologyService implements IPatologyService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: PatologyApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<PatologyApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: PatologyDTO): Observable<Patology | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<Patology | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<PatologyQuery>): Observable<ItemList<Patology>> {
    return this._api.getFilteredList(q).pipe()
  }

  update(e: PatologyDTO): Observable<Patology | undefined> {
    return this._api.update(e)
  }
}
